import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { ChatActionButton } from "@/ui/Chat/ChatActionButton";
import type { AnnieFeedbackRating } from "@/utils/annieStream";

type Props = {
	conversationId: number;
	rating: AnnieFeedbackRating | null;
	isSaving: boolean;
	isSavingDetails: boolean;
	onHelpful: () => void;
	onUnhelpful: () => void;
};

/** The two rating actions for an answer — siblings of copy/regenerate in the same `ChatActionBar`. */
export const AnnieFeedbackRatingButtons: FC<Props> = ({ conversationId, rating, isSaving, isSavingDetails, onHelpful, onUnhelpful }) => {
	const { t } = useTranslation();
	const disabled = isSaving || isSavingDetails;
	return (
		<>
			<ChatActionButton
				label={t("annie.feedback.helpful")}
				icon={rating === "helpful" ? <ThumbUpAltIcon /> : <ThumbUpAltOutlinedIcon />}
				onClick={onHelpful}
				active={rating === "helpful"}
				loading={isSaving && rating === "helpful"}
				disabled={disabled}
				dataTestId={`annie-feedback-helpful-button-${conversationId}`}
			/>
			<ChatActionButton
				label={t("annie.feedback.unhelpful")}
				icon={rating === "unhelpful" ? <ThumbDownAltIcon /> : <ThumbDownAltOutlinedIcon />}
				onClick={onUnhelpful}
				active={rating === "unhelpful"}
				loading={isSaving && rating === "unhelpful"}
				disabled={disabled}
				dataTestId={`annie-feedback-unhelpful-button-${conversationId}`}
			/>
		</>
	);
};
